import { Datapoint } from '../../../../model/datapoint/datapoint';
import { DatasetFieldType } from '../../../../model/dataset/dataset-field-type';
import { DatasetField } from '../../../../model/dataset/field/dataset-field';
import { DatapointField } from '../../../../model/datapoint/datapoint-field';
import { NRIUtils } from '../../../../core/tessadata/nri-utils';
import { TessadataNriFields } from '../../../../core/tessadata/tessadata-nri-fields';
import { Functionalities } from '../../../../../environments/app-functionalities';
import { isEnabled } from '../../../../../environments/environment';
import { DatasetFieldScope } from '../../../../model/dataset/dataset-field-scope';
import { TessadataService } from '../../../../data-access-layer/tessadata.service';
import { TessadataFieldsValues } from '../../../../core/tessadata/tessadata-fields-values';
import { TessadataDataset } from '../../../../core/tessadata/tessadata-dataset';
import { TessadataDatasetStructure } from '../../../../core/tessadata/tessadata-dataset-structure';
import { DistanceUnit } from '../../../../constants';
import { ComputationUtils } from '../../../../core/utils/computation-utils';
import { AerisService } from '../../../../data-access-layer/aeris.service';
import { AerisType } from '../../../../core/aeris/AerisType';
import { decodeHtmlText, isObject, isUndefined } from "src/app/core/utils/util-master";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { PoiClosestFilter } from 'src/app/model/datapoint/filter/poi-closest-filter';
import { EChartsOption } from 'echarts';
import { ClimateOverlayPermission, DatapointsClimateChartService } from '../../climate-charts/datapoints-climate-chart.service';
import { ConsolidatedRiskScoreChartService } from '../../climate-charts/consolidated-risk-score-chart.service';
import { ClimateChartHelper } from '../../climate-charts/util/climate-chart-helper';
import { ClimateChart } from '../../../../model/climate/climate-chart';
import { ClimateService } from 'src/app/data-access-layer/climate.service';
import { LocationProfile } from 'src/app/model/datapoint/location-profile/location-profile';
import { Aeris } from 'src/app/core/utils/aeris';
//import { TensorflightKeys, TensorflightStatus } from '../../tensorflight-keys';
import { MaptycsTheme } from '../../climate-charts/custom-theme';
import { MinuchRe } from 'src/app/core/utils/minuch-re';
import { DownloadService } from 'src/app/data-access-layer/download/download.service';
import { forkJoin, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { keepRegionLevelsBetweenTicks, RegionChartItem, toRegionChartItem } from '../../climate-charts/region-chart';
import { BioclimaticRegion } from 'src/app/model/climate/bioclimatic-region';
import { AttachmentUtils } from 'src/app/core/utils/attachment-utils';
import { NotifService } from 'src/app/core/notification/notif.service';
import {WorkspaceItemService} from '../../../../data-access-layer/workspace-item/workspace-item.service';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { ActivatedRoute } from '@angular/router';
import { UserStateService } from 'src/app/auth/user-state-service';
import { ActivityConfigService } from 'src/app/account/consolidated-risk-score/services/activity-config.service';
import {
    Activity,
    Indicator,
    IndicatorValue,
    isNotApplicableProfile,
} from 'src/app/account/consolidated-risk-score/model/activity-config.model';
import { ScenarioSSP, TimePeriod } from 'src/app/model/dataset/rendering/climatology-options';
import { SCENARIO_LABELS, TIME_PERIOD_LABELS } from '../../../../map/map/datapoint-map-legend/legend-label.constants';

export interface AerisData {
    depth: number;
    text: string;
    value: string;
}

export interface ConsolidatedRiskScoreChartItem {
    profileId: number;
    profileName: string;
    title: string;
    fileName: string;
    option: EChartsOption;
    hasData: boolean;
    message?: string;
    instance?: any;
}

@Component({
    selector: 'map-location-profile',
    templateUrl: './location-profile.component.html',
    styleUrls: ['./location-profile.component.scss', '../datapoints-profile-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationProfileComponent implements OnInit, OnDestroy  {


    _datapoint: Datapoint;
    _dropdownSelectedValue: string;
    @Input() tessadataPOIDatasets: TessadataDataset[] = [];
    @Input() tessadataPOIDatasetsStructures: TessadataDatasetStructure[] = [];

    @Input("datasetFields") datasetFields: { [key: number]: DatasetField };
    @Output() poiClosestSubmittedFilter = new EventEmitter<PoiClosestFilter>();

    datapointFieldsByIds: { [key: string]: DatapointField; } = {};

    nriCards: NRICard[] = [];
    summaryCard: NRICard;
    tessadataEnabled = isEnabled(Functionalities.TESSADATA_DATA);

    tessadataPOIDetails: TessadataFieldsValues[]; //each entry belongs to a new POI
    tessadataPOIDataset: TessadataDataset;
    tessadataPOIDistance: number = 100; //maybe extract this into constants
    tessadataPOIDistanceUnit: DistanceUnit = DistanceUnit.KM;
    tessadataPOISubmittedDistanceUnit: DistanceUnit = DistanceUnit.KM;
    tessadataPOILimit: number = 5; //maybe extract this into constant

    apgFields: DatapointField[];
    externalFields: DatapointField[];
//    tensorflightFields: DatapointField[];
    e2valueFields: DatapointField[];
    meteorologicalConditionsData: AerisData[] = [];
    earthquakesData: AerisData[] = [];
    placesData: AerisData[] = [];
    munichReFields: DatapointField[];
    customScoreFields: DatapointField[];
    consolidatedRiskScoreCharts: ConsolidatedRiskScoreChartItem[] = [];
    consolidatedRiskScoreLoading = false;
    consolidatedRiskScoreNoData = false;
    consolidatedRiskScoreNoDataMessage = 'No consolidated risk score for this location.';

    initMaxTempOption: EChartsOption;
    initMeanTempOption: EChartsOption;
    initMinTempOption: EChartsOption;
    initSnowfallOption: EChartsOption;
    initPrecipitationOption: EChartsOption;
    initSurfaceWindOption: EChartsOption;
    initPopulationDensityOption: EChartsOption;
    initSeaLevelRiseOption: EChartsOption;
    initSeaLevelRiseWarmingOption: EChartsOption;
    initSpi6ChangeOption: EChartsOption;
    initSpi6ScoreOption: EChartsOption;
    initCoolingDegreeDaysOption: EChartsOption;
    initCoolingDegreeDaysScoreOption: EChartsOption;
    initCoolingDegreeDaysChangeOption: EChartsOption;
    initTxxOption: EChartsOption;
    initTxxScoreOption: EChartsOption;
    initTxxChangeOption: EChartsOption;
    initClimateTOption: EChartsOption;
    initClimateTScoreOption: EChartsOption;
    initClimateTChangeOption: EChartsOption;
    initFrostDaysOption: EChartsOption;
    initFrostDaysScoreOption: EChartsOption;
    initFrostDaysChangeOption: EChartsOption;
    initHeatingDegreeDaysOption: EChartsOption;
    initHeatingDegreeDaysScoreOption: EChartsOption;
    initHeatingDegreeDaysChangeOption: EChartsOption;
    initExtremeHotDaysOption: EChartsOption;
    initExtremeHotDaysScoreOption: EChartsOption;
    initExtremeHotDaysChangeOption: EChartsOption;
    initVeryExtremeHotDaysOption: EChartsOption;
    initVeryExtremeHotDaysScoreOption: EChartsOption;
    initVeryExtremeHotDaysChangeOption: EChartsOption;
    initClimatePrOption: EChartsOption;
    initClimatePrScoreOption: EChartsOption;
    initClimatePrChangeOption: EChartsOption;
    initClimateCddOption: EChartsOption;
    initClimateCddScoreOption: EChartsOption;
    initClimateCddChangeOption: EChartsOption;
    initClimateRx1dayOption: EChartsOption;
    initClimateRx1dayScoreOption: EChartsOption;
    initClimateRx1dayChangeOption: EChartsOption;
    initClimateRx5dayOption: EChartsOption;
    initClimateRx5dayScoreOption: EChartsOption;
    initClimateRx5dayChangeOption: EChartsOption;
    initClimatePrsnOption: EChartsOption;
    initClimatePrsnScoreOption: EChartsOption;
    initClimatePrsnChangeOption: EChartsOption;
    initClimateSstOption: EChartsOption;
    initClimateSstScoreOption: EChartsOption;
    initClimateSstChangeOption: EChartsOption;
    initClimateSfcWindOption: EChartsOption;
    initClimateSfcWindScoreOption: EChartsOption;
    initClimateSfcWindChangeOption: EChartsOption;
    initClimateTrOption: EChartsOption;
    initClimateTrScoreOption: EChartsOption;
    initClimateTrChangeOption: EChartsOption;
    initClimateSlrOption: EChartsOption;
    initClimateSlrScoreOption: EChartsOption;
    initClimateSlrChangeOption: EChartsOption;

    locationProfile = new LocationProfile();
    panelOpenState = false;
    // tensorflightKeysEnum = TensorflightKeys;
    // currentTensorFlightStatus: string;
    // tensorflightSuccess = TensorflightStatus.SUCCESS;
    maptycsTheme = MaptycsTheme;

    hazardScores = MinuchRe.HazardScoresElements();
    riskScores = MinuchRe.RiskScoresElements();
    dataSource: any;
    riskDataSource: any;
    formulaFields: { [key: string]: number }[] = [];
    formulaFieldsArray: { key: string, value: number }[] = [];
    isLoadingFormulaData: boolean = false;
    private readonly subscriptions: Subscription = new Subscription();
    preciselyWildfireRiskFields: DatapointField[];
    preciselyBuildingFields: DatapointField[];
    preciselyCrimeFields: DatapointField[];
    climatologyActiveTab: 'CLIMATOLOGY' | 'CHANGE' | 'RISK_SCORING' | 'REGION' | 'CONSOLIDATED_RISK_SCORE' = 'RISK_SCORING';
    bioclimaticZonesEnabled = false;
    regionLoading = false;
    regionCharts: RegionChartItem[] = [];
    private regionRequest: Subscription | null = null;
    // Shown in the profile data section, so loaded with the location rather than with the Region tab.
    bioclimaticRegion: BioclimaticRegion | null = null;
    private bioclimaticRegionRequest: Subscription | null = null;

    // Consolidated Risk Score - instant calculation (FR-1.50-1.56): a live score for one
    // location, computed from percentages the user may edit, never saved or persisted.
    instantVulnerabilityProfiles: Activity[] = [];
    instantIndicators: Indicator[] = [];
    instantOptionsLoaded = false;
    instantLoadingOptions = false;
    instantLoadingConfig = false;
    instantCalculating = false;
    instantSelectedProfileId: number | null = null;
    instantIndicatorValues: { [code: string]: number | null } = {};
    instantErrorMessage = '';
    // The instant result is its own chart, kept separate from the stored one so the two carry
    // different labels and so recalculating simply replaces this (FR-1.65).
    instantChartItem: ConsolidatedRiskScoreChartItem | null = null;

    constructor(
        private tessadataService: TessadataService,
        private aerisService: AerisService,
        private changeDetector: ChangeDetectorRef,
        private datapointsClimateChartService: DatapointsClimateChartService,
        private consolidatedRiskScoreChartService: ConsolidatedRiskScoreChartService,
        private climateService: ClimateService,
        public readonly climateOverlayPermission: ClimateOverlayPermission,
        private readonly downloadService: DownloadService,
        public readonly notifService: NotifService,
        public readonly workspaceItemService: WorkspaceItemService,
        private readonly analytics: AnalyticsService,
        private readonly route: ActivatedRoute,
        private readonly userStateService: UserStateService,
        private readonly activityConfigService: ActivityConfigService
        ) {

        this.initMaxTempOption = datapointsClimateChartService.maxTemperatureService.options;
        this.initMeanTempOption = datapointsClimateChartService.meanTemperatureService.options;
        this.initMinTempOption = datapointsClimateChartService.minTemperatureService.options;
        this.initSnowfallOption = datapointsClimateChartService.snowfallService.options;
        this.initPrecipitationOption = datapointsClimateChartService.precipitationService.options;
        this.initSurfaceWindOption = datapointsClimateChartService.surfaceWindService.options;
        this.initPopulationDensityOption = datapointsClimateChartService.populationDensityService.options;
        this.initSeaLevelRiseOption = datapointsClimateChartService.seaLevelRiseService.options;
        this.initSeaLevelRiseWarmingOption = datapointsClimateChartService.seaLevelRiseWarmingService.options;
        this.initSpi6ChangeOption = datapointsClimateChartService.spi6ChangeService.options;
        this.initSpi6ScoreOption = datapointsClimateChartService.spi6ScoreService.options;
        this.initCoolingDegreeDaysOption = datapointsClimateChartService.coolingDegreeDaysService.options;
        this.initCoolingDegreeDaysScoreOption = datapointsClimateChartService.coolingDegreeDaysScoreService.options;
        this.initCoolingDegreeDaysChangeOption = datapointsClimateChartService.coolingDegreeDaysChangeService.options;
        this.initTxxOption = datapointsClimateChartService.txxService.options;
        this.initTxxScoreOption = datapointsClimateChartService.txxScoreService.options;
        this.initTxxChangeOption = datapointsClimateChartService.txxChangeService.options;
        this.initClimateTOption = datapointsClimateChartService.climateTService.options;
        this.initClimateTScoreOption = datapointsClimateChartService.climateTScoreService.options;
        this.initClimateTChangeOption = datapointsClimateChartService.climateTChangeService.options;
        this.initFrostDaysOption = datapointsClimateChartService.frostDaysService.options;
        this.initFrostDaysScoreOption = datapointsClimateChartService.frostDaysScoreService.options;
        this.initFrostDaysChangeOption = datapointsClimateChartService.frostDaysChangeService.options;
        this.initHeatingDegreeDaysOption = datapointsClimateChartService.heatingDegreeDaysService.options;
        this.initHeatingDegreeDaysScoreOption = datapointsClimateChartService.heatingDegreeDaysScoreService.options;
        this.initHeatingDegreeDaysChangeOption = datapointsClimateChartService.heatingDegreeDaysChangeService.options;
        this.initExtremeHotDaysOption = datapointsClimateChartService.extremeHotDaysService.options;
        this.initExtremeHotDaysScoreOption = datapointsClimateChartService.extremeHotDaysScoreService.options;
        this.initExtremeHotDaysChangeOption = datapointsClimateChartService.extremeHotDaysChangeService.options;
        this.initVeryExtremeHotDaysOption = datapointsClimateChartService.veryExtremeHotDaysService.options;
        this.initVeryExtremeHotDaysScoreOption = datapointsClimateChartService.veryExtremeHotDaysScoreService.options;
        this.initVeryExtremeHotDaysChangeOption = datapointsClimateChartService.veryExtremeHotDaysChangeService.options;
        this.initClimatePrOption = datapointsClimateChartService.climatePrService.options;
        this.initClimatePrScoreOption = datapointsClimateChartService.climatePrScoreService.options;
        this.initClimatePrChangeOption = datapointsClimateChartService.climatePrChangeService.options;
        this.initClimateCddOption = datapointsClimateChartService.climateCddService.options;
        this.initClimateCddScoreOption = datapointsClimateChartService.climateCddScoreService.options;
        this.initClimateCddChangeOption = datapointsClimateChartService.climateCddChangeService.options;
        this.initClimateRx1dayOption = datapointsClimateChartService.climateRx1dayService.options;
        this.initClimateRx1dayScoreOption = datapointsClimateChartService.climateRx1dayScoreService.options;
        this.initClimateRx1dayChangeOption = datapointsClimateChartService.climateRx1dayChangeService.options;
        this.initClimateRx5dayOption = datapointsClimateChartService.climateRx5dayService.options;
        this.initClimateRx5dayScoreOption = datapointsClimateChartService.climateRx5dayScoreService.options;
        this.initClimateRx5dayChangeOption = datapointsClimateChartService.climateRx5dayChangeService.options;
        this.initClimatePrsnOption = datapointsClimateChartService.climatePrsnService.options;
        this.initClimatePrsnScoreOption = datapointsClimateChartService.climatePrsnScoreService.options;
        this.initClimatePrsnChangeOption = datapointsClimateChartService.climatePrsnChangeService.options;
        this.initClimateSstOption = datapointsClimateChartService.climateSstService.options;
        this.initClimateSstScoreOption = datapointsClimateChartService.climateSstScoreService.options;
        this.initClimateSstChangeOption = datapointsClimateChartService.climateSstChangeService.options;
        this.initClimateSfcWindOption = datapointsClimateChartService.climateSfcWindService.options;
        this.initClimateSfcWindScoreOption = datapointsClimateChartService.climateSfcWindScoreService.options;
        this.initClimateSfcWindChangeOption = datapointsClimateChartService.climateSfcWindChangeService.options;
        this.initClimateTrOption = datapointsClimateChartService.climateTrService.options;
        this.initClimateTrScoreOption = datapointsClimateChartService.climateTrScoreService.options;
        this.initClimateTrChangeOption = datapointsClimateChartService.climateTrChangeService.options;
        this.initClimateSlrOption = datapointsClimateChartService.climateSlrService.options;
        this.initClimateSlrScoreOption = datapointsClimateChartService.climateSlrScoreService.options;
        this.initClimateSlrChangeOption = datapointsClimateChartService.climateSlrChangeService.options;
    }

    ngOnDestroy(): void {
        this.datapointsClimateChartService.unsubscribeLocationChartInstances();
        // Held on a service shared with the next panel, so a closed location's Region charts
        // must not be downloaded from it.
        this.regionRequest?.unsubscribe();
        this.bioclimaticRegionRequest?.unsubscribe();
        this.datapointsClimateChartService.regionGraphs = [];
        this.datapointsClimateChartService.bioclimaticRegion = null;
        this.datapointsClimateChartService.regionDownloadPayload = {};
        // The instant result is held on a service shared with the address panel, so leaving it set
        // would export this location's calculation from whichever panel opens next.
        this.datapointsClimateChartService.consolidatedRiskScoreInstantChart = null;
        this.subscriptions.unsubscribe();
    }

    onMaxTempChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.maxTemperature.instance = ec;
        }
        this.datapointsClimateChartService.maxTemperatureService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onMeanTempChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.meanTemperature.instance = ec;
        }
        this.datapointsClimateChartService.meanTemperatureService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onMinTempChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.minTemperature.instance = ec;
        }
        this.datapointsClimateChartService.minTemperatureService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSnowfallChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.snowfallTemperature.instance = ec;
        }
        this.datapointsClimateChartService.snowfallService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onPrecipitationChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.precipitation.instance = ec;
        }
        this.datapointsClimateChartService.precipitationService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSurfaceWindChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.surfaceWind.instance = ec;
        }
        this.datapointsClimateChartService.surfaceWindService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onPopulationDensityCharInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.populationDensity.instance = ec;
        }
        this.datapointsClimateChartService.populationDensityService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSeaLevelRiseChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.seaLevelRise.instance = ec;
        }
        this.datapointsClimateChartService.seaLevelRiseService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSeaLevelRiseWarmingChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.seaLevelRiseWarming.instance = ec;
        }
        this.datapointsClimateChartService.seaLevelRiseWarmingService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSpi6ChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.spi6Change.instance = ec;
        }
        this.datapointsClimateChartService.spi6ChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSpi6ScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.spi6Score.instance = ec;
        }
        this.datapointsClimateChartService.spi6ScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onCoolingDegreeDaysChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDays.instance = ec;
        }
        this.datapointsClimateChartService.coolingDegreeDaysService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onCoolingDegreeDaysScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.coolingDegreeDaysScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onCoolingDegreeDaysChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.coolingDegreeDaysChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onTxxChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txx.instance = ec;
        }
        this.datapointsClimateChartService.txxService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onTxxScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txxScore.instance = ec;
        }
        this.datapointsClimateChartService.txxScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onTxxChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txxChange.instance = ec;
        }
        this.datapointsClimateChartService.txxChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateT.instance = ec;
        }
        this.datapointsClimateChartService.climateTService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTScore.instance = ec;
        }
        this.datapointsClimateChartService.climateTScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTChange.instance = ec;
        }
        this.datapointsClimateChartService.climateTChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onFrostDaysChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.frostDays.instance = ec;
        }
        this.datapointsClimateChartService.frostDaysService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onFrostDaysScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.frostDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.frostDaysScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onFrostDaysChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.frostDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.frostDaysChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onHeatingDegreeDaysChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.heatingDegreeDays.instance = ec;
        }
        this.datapointsClimateChartService.heatingDegreeDaysService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onHeatingDegreeDaysScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.heatingDegreeDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.heatingDegreeDaysScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onHeatingDegreeDaysChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.heatingDegreeDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.heatingDegreeDaysChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onExtremeHotDaysChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.extremeHotDays.instance = ec;
        }
        this.datapointsClimateChartService.extremeHotDaysService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onExtremeHotDaysScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.extremeHotDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.extremeHotDaysScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onExtremeHotDaysChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.extremeHotDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.extremeHotDaysChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onVeryExtremeHotDaysChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.veryExtremeHotDays.instance = ec;
        }
        this.datapointsClimateChartService.veryExtremeHotDaysService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onVeryExtremeHotDaysScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.veryExtremeHotDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.veryExtremeHotDaysScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onVeryExtremeHotDaysChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.veryExtremeHotDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.veryExtremeHotDaysChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePr.instance = ec;
        }
        this.datapointsClimateChartService.climatePrService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrScore.instance = ec;
        }
        this.datapointsClimateChartService.climatePrScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrChange.instance = ec;
        }
        this.datapointsClimateChartService.climatePrChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateCddChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateCdd.instance = ec;
        }
        this.datapointsClimateChartService.climateCddService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateCddScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateCddScore.instance = ec;
        }
        this.datapointsClimateChartService.climateCddScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateCddChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateCddChange.instance = ec;
        }
        this.datapointsClimateChartService.climateCddChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx1dayChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx1day.instance = ec;
        }
        this.datapointsClimateChartService.climateRx1dayService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx1dayScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx1dayScore.instance = ec;
        }
        this.datapointsClimateChartService.climateRx1dayScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx1dayChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx1dayChange.instance = ec;
        }
        this.datapointsClimateChartService.climateRx1dayChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx5dayChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx5day.instance = ec;
        }
        this.datapointsClimateChartService.climateRx5dayService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx5dayScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx5dayScore.instance = ec;
        }
        this.datapointsClimateChartService.climateRx5dayScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx5dayChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx5dayChange.instance = ec;
        }
        this.datapointsClimateChartService.climateRx5dayChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrsnChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrsn.instance = ec;
        }
        this.datapointsClimateChartService.climatePrsnService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrsnScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrsnScore.instance = ec;
        }
        this.datapointsClimateChartService.climatePrsnScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrsnChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrsnChange.instance = ec;
        }
        this.datapointsClimateChartService.climatePrsnChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSstChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSst.instance = ec;
        }
        this.datapointsClimateChartService.climateSstService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSstScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSstScore.instance = ec;
        }
        this.datapointsClimateChartService.climateSstScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSstChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSstChange.instance = ec;
        }
        this.datapointsClimateChartService.climateSstChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSfcWindChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSfcWind.instance = ec;
        }
        this.datapointsClimateChartService.climateSfcWindService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSfcWindScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSfcWindScore.instance = ec;
        }
        this.datapointsClimateChartService.climateSfcWindScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSfcWindChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSfcWindChange.instance = ec;
        }
        this.datapointsClimateChartService.climateSfcWindChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTrChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTr.instance = ec;
        }
        this.datapointsClimateChartService.climateTrService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTrScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTrScore.instance = ec;
        }
        this.datapointsClimateChartService.climateTrScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTrChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTrChange.instance = ec;
        }
        this.datapointsClimateChartService.climateTrChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSlrChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlr.instance = ec;
        }
        this.datapointsClimateChartService.climateSlrService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSlrScoreChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlrScore.instance = ec;
        }
        this.datapointsClimateChartService.climateSlrScoreService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSlrChangeChartInit(ec) {
        if (!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlrChange.instance = ec;
        }
        this.datapointsClimateChartService.climateSlrChangeService.emitLocationChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    ngOnInit(): void {
        this.tessadataPOIDataset = this.tessadataPOIDatasets[0];
        this.fetchClosestPOI();
        this.aerisFetch();
        this.analytics.trackEvent('location_profile_opened');
    }

    @Input('datapoint')
    set datapoint(datapoint: Datapoint) {
        if (datapoint) {
            this._datapoint = datapoint;
            this.prepareClimateCharts(this._datapoint);
            this.loadBioclimaticRegion(this._datapoint);
            datapoint.fields.forEach(field => {
                this.datapointFieldsByIds[field.id] = field;
                field.isPresent = field.numberValue || field.textValue || field.datetimeValue;
                field.isPresent = typeof(field.numberValue) === 'number' && Math.round(field.numberValue) == 0 ? true : field.isPresent;
                field.scope = this.datasetFields[field.id].scope;
            });

            this.externalFields = this._datapoint.fields.filter(field => {
                let datasetField = this.datasetFields[field.id];
                return field.isPresent
                    && (datasetField.scope === DatasetFieldScope.EXTERNAL)
                    && !this.isPrecisely(datasetField)
                //    && !this.isTensorFlight(datasetField);
            });
            // this.tensorflightFields = this._datapoint.fields.filter(field => {
            //     let datasetField = this.datasetFields[field.id];
            //     return field.isPresent
            //         && this.isTensorFlight(datasetField);
            // });
            this.e2valueFields = this._datapoint.fields.filter(field => {
                let datasetField = this.datasetFields[field.id];
                return field.isPresent
                    && this.isE2Value(datasetField);
            });
            this.apgFields = this._datapoint.fields.filter(field => {
                let datasetField = this.datasetFields[field.id];
                return field.isPresent
                    && (datasetField.scope === DatasetFieldScope.EXTERNAL)
                    && this.isPrecisely(datasetField);
            });
            this.munichReFields = this._datapoint.fields.filter(field => {
                let datasetField = this.datasetFields[field.id];
                return field.isPresent
                    && (datasetField.scope === DatasetFieldScope.MUNICHRE)
                    && this.isMunichRe(datasetField);
            });
            this.preciselyBuildingFields = this._datapoint.fields.filter(field => {
                let datasetField = this.datasetFields[field.id];
                return field.isPresent
                    && (datasetField.scope === DatasetFieldScope.PRECISELY_BUILDING)
                    && this.isPreciselyBuilding(datasetField);
            });
            this.preciselyCrimeFields = this._datapoint.fields.filter(field => {
                let datasetField = this.datasetFields[field.id];
                return field.isPresent
                    && (datasetField.scope === DatasetFieldScope.PRECISELY_CRIME)
                    && this.isPreciselyCrime(datasetField);
            });
            this.preciselyWildfireRiskFields = this._datapoint.fields.filter(field => {
                let datasetField = this.datasetFields[field.id];
                return field.isPresent
                    && (datasetField.scope === DatasetFieldScope.PRECISELY_WILDFIRE_RISK)
                    && this.isPreciselyWildfireRisk(datasetField);
            });
            this.customScoreFields = this._datapoint.fields.filter(field => {
                let datasetField = this.datasetFields[field.id];
                return field.isPresent
                    && (this.isCustomScore(datasetField));
            });
            this.munichReFields.forEach(field => {
                let datasetField = this.datasetFields[field.id];
                    this.hazardScores.forEach(hazardScore => {
                        if (hazardScore.id === datasetField.id) {
                            hazardScore.values.forEach((item) => {
                                // Iterate over the keys of each object
                                Object.keys(item).forEach((key) => {
                                    const value = item[key];
                                    if(value.value == field.numberValue || (field.numberValue && value.value == field.numberValue.toFixed(4).replace(/\.0+$/,''))) {
                                        value.isActive = true;
                                        value.class = 'progress-bar active';
                                        value.tooltip = value.tooltip + value.value;
                                    } else {
                                        value.tooltip = '';
                                    }
                                });
                            });
                        }
                    });
            });
            this.dataSource = this.hazardScores;
            this.riskDataSource = this.riskScores;
            this.prepareNRICards();
        }
    }

    @Input('dropdownSelectedValue')
    set dropdownSelectedValue(dropdownSelectedValue: string) {
        if (dropdownSelectedValue) {
            this._dropdownSelectedValue = dropdownSelectedValue;
            if (this._dropdownSelectedValue === this.locationProfile.CLIMATE) {
                this.prepareClimateCharts(this._datapoint);
            } else if (this._dropdownSelectedValue === this.locationProfile.CLIMATE_CHANGE) {
                this.setClimatologyTab('RISK_SCORING');
                this.prepareClimatologyCharts(this._datapoint);
            } else if (this._dropdownSelectedValue === this.locationProfile.FORMULA) {
                this.loadFormulaData();
            }
        }
    }

    /**
     * Who may use the instant calculation section (FR-1.2/FR-1.3): Super Admin and Client
     * Admin, same as Account Settings - a Client Member can read stored scores but not test
     * a hypothetical percentage split.
     */
    get canAccessInstantCalculation(): boolean {
        const accountId = this.instantAccountId;
        return accountId != null && (this.userStateService.isSuperadmin || !!this.userStateService.isAccountAdmin(accountId));
    }

    get TimePeriod() {
        return TimePeriod;
    }

    get timePeriodOptions(): TimePeriod[] {
        return Object.values(TimePeriod);
    }

    get scenarioOptions(): ScenarioSSP[] {
        return Object.values(ScenarioSSP);
    }

    getTimePeriodLabel(timePeriod: TimePeriod): string {
        return TIME_PERIOD_LABELS[timePeriod] || timePeriod;
    }

    getScenarioLabel(scenario: ScenarioSSP): string {
        return SCENARIO_LABELS[scenario] || scenario;
    }

    /**
     * Sum of the entered instant-calculation percentages, rounded against float drift from
     * decimal entries (e.g. 33.33 + 33.33 + 33.34) - mirrors EditProfileDialogComponent.
     */
    get instantTotalPercentage(): number {
        const total = this.instantIndicators.reduce((sum, indicator) => {
            const entered = this.instantIndicatorValues[indicator.code];
            const percentage = entered === null || entered === undefined || entered === ('' as any) ? 0 : Number(entered);
            return sum + (isNaN(percentage) ? 0 : percentage);
        }, 0);
        return Math.round(total * 100) / 100;
    }

    private get instantAccountId(): number | null {
        const accountId = this.route.snapshot.paramMap.get('accountId');
        return accountId ? Number(accountId) : null;
    }

    private loadInstantCalculationOptions() {
        if (this.instantOptionsLoaded || this.instantLoadingOptions) {
            return;
        }
        this.instantLoadingOptions = true;
        forkJoin({
            profiles: this.activityConfigService.getActivities(),
            indicators: this.activityConfigService.getIndicators(),
        }).subscribe({
            next: ({ profiles, indicators }) => {
                this.instantVulnerabilityProfiles = profiles;
                this.instantIndicators = indicators;
                this.instantOptionsLoaded = true;
                this.instantLoadingOptions = false;
                this.changeDetector.detectChanges();
            },
            error: () => {
                this.instantErrorMessage = 'Failed to load vulnerability profile types.';
                this.instantLoadingOptions = false;
                this.changeDetector.detectChanges();
            }
        });
    }

    /** A profile was picked (or cleared): load its saved percentages as the editable starting point. */
    /**
     * NOT APPLICABLE holds no percentages: they are fixed at 0% and read-only here, exactly as in
     * Account Settings.
     */
    get isInstantProfileNotApplicable(): boolean {
        const profile = this.instantVulnerabilityProfiles
            .find(candidate => candidate.id === this.instantSelectedProfileId);
        return isNotApplicableProfile(profile?.name);
    }

    onInstantProfileChange() {
        this.clearInstantResult();
        this.instantIndicatorValues = {};
        if (this.instantSelectedProfileId == null) {
            return;
        }
        if (this.isInstantProfileNotApplicable) {
            // Fixed at 0 rather than read from the saved config: the boxes are read-only, so they
            // have to show the value that will actually be used, and it is always 0.
            this.instantIndicators.forEach(indicator => (this.instantIndicatorValues[indicator.code] = 0));
            return;
        }
        const accountId = this.instantAccountId;
        if (accountId == null) {
            return;
        }
        this.instantLoadingConfig = true;
        this.activityConfigService.getConfig(accountId, this.instantSelectedProfileId).subscribe({
            next: (config) => {
                const valueByIndicatorId = new Map<number, number>();
                (config?.indicatorValues || []).forEach(indicatorValue => valueByIndicatorId.set(indicatorValue.indicatorId, indicatorValue.value));
                this.instantIndicators.forEach(indicator => {
                    const decimalValue = valueByIndicatorId.get(indicator.id);
                    this.instantIndicatorValues[indicator.code] = decimalValue !== undefined ? decimalValue * 100 : null;
                });
                this.instantLoadingConfig = false;
                this.changeDetector.detectChanges();
            },
            error: () => {
                this.instantIndicators.forEach(indicator => (this.instantIndicatorValues[indicator.code] = null));
                this.instantLoadingConfig = false;
                this.changeDetector.detectChanges();
            }
        });
    }

    onInstantInputChanged() {
        this.clearInstantResult();
    }

    private clearInstantResult() {
        // The chart is deregistered as well as dropped from the view. The download list is keyed
        // by title, so a previous result calculated against a different profile type would keep
        // its own entry and be exported alongside the new one - three sections instead of two,
        // one of them pointing at a disposed chart instance.
        if (this.instantChartItem) {
            this.deregisterConsolidatedRiskScoreGraph(this.instantChartItem.title);
        }
        this.datapointsClimateChartService.consolidatedRiskScoreInstantChart = null;
        this.instantChartItem = null;
        this.instantErrorMessage = '';
    }

    private deregisterConsolidatedRiskScoreGraph(title: string) {
        const graphs = this.datapointsClimateChartService.consolidatedRiskScoreGraphs;
        const existing = graphs.findIndex(graph => graph.title === title);
        if (existing !== -1) {
            graphs.splice(existing, 1);
        }
    }

    /**
     * Computes the score live from whatever is currently entered (FR-1.54/1.56) - nothing
     * here is saved, and it never touches a stored score, colorization, filter, or analytics.
     */
    /**
     * Calculates the score for all 16 scenario/period combinations at once and draws them as a
     * second chart. No scenario or time period is chosen in the card - the profile type
     * and its percentages are the whole input.
     */
    calculateInstantScore() {
        if (this.instantSelectedProfileId == null) {
            this.notifService.error('Please select a vulnerability profile type');
            return;
        }
        // NOT APPLICABLE is exempt from the 100% rule - it totals 0% by definition (FR-1.21).
        if (!this.isInstantProfileNotApplicable) {
            const total = this.instantTotalPercentage;
            if (total !== 100) {
                this.notifService.error(`Indicator percentages must total 100% - currently ${total}%`);
                return;
            }
        }

        this.instantCalculating = true;
        // Drop the previous result up front: a recalculation replaces it rather than adding to it
        // and leaving the old chart on screen while the new one loads reads as current.
        this.instantChartItem = null;
        this.instantErrorMessage = '';

        const indicatorValues: IndicatorValue[] = this.instantIndicators.map(indicator => {
            const entered = this.instantIndicatorValues[indicator.code];
            const percentage = entered === null || entered === undefined ? 0 : Number(entered);
            return { indicatorId: indicator.id, value: percentage / 100 };
        });

        this.climateService.computeInstantConsolidatedRiskScoreChart(
            this._datapoint.datasetID, this._datapoint.id, this.instantSelectedProfileId, indicatorValues
        ).subscribe({
            next: (chart) => {
                this.instantChartItem = this.toInstantChartItem(chart);
                if (!this.instantChartItem.hasData) {
                    this.instantErrorMessage = chart?.message
                        || 'No consolidated risk score available for this location.';
                } else {
                    // Handed to the download service so Download Data can carry it as its own
                    // section: it is never stored, so it cannot be read back from the datapoint.
                    this.datapointsClimateChartService.consolidatedRiskScoreInstantChart = chart;
                }
                this.instantCalculating = false;
                this.changeDetector.detectChanges();
            },
            error: () => {
                this.instantErrorMessage = 'Failed to calculate the consolidated risk score.';
                this.instantCalculating = false;
                this.changeDetector.detectChanges();
            }
        });
    }

    /**
     * Wraps the returned chart in the same item the stored graphs use, so it inherits the bar,
     * line, tabular and save-image toolbox without a second renderer (AC-1.46). The backend
     * already prefixes the label with "Instant Calculation".
     */
    private toInstantChartItem(chart: ClimateChart): ConsolidatedRiskScoreChartItem {
        const profile = this.instantVulnerabilityProfiles
            .find(candidate => candidate.id === this.instantSelectedProfileId);
        const title = chart?.chartConfig?.yAxis?.labelName || `Instant Calculation ${profile?.name ?? ''}`.trim();
        const hasData = !!chart && chart.hasData !== false;

        return {
            profileId: this.instantSelectedProfileId,
            profileName: profile?.name ?? '',
            title,
            fileName: this.consolidatedRiskScoreChartService.toFileName(title),
            option: hasData ? this.consolidatedRiskScoreChartService.buildChartOptions(chart) : {} as EChartsOption,
            hasData,
            message: hasData ? undefined : (chart?.message || 'No consolidated risk score available for this location.')
        };
    }

    /**
     * Loads formula data for the current datapoint.
     * Fetches formulas from the workspace service and processes them for display.
     */
    private loadFormulaData() {
        this.isLoadingFormulaData = true;
        this.formulaFieldsArray = []; // Reset array

        this.workspaceItemService.fetchFormulasByDatasetAndDatapoint(this._datapoint.datasetID, this._datapoint.id).subscribe({
            next: (formulas) => {
                this.formulaFields = formulas;
                this.formulaFieldsArray = this.formulaFields.reduce((acc, map) => {
                    return acc.concat(
                        Object.entries(map).map(([key, value]) => ({
                            key: decodeHtmlText(key),
                            value: typeof (value) === 'number' ? value.toFixed(2) : value
                        }))
                    );
                }, []);
                this.isLoadingFormulaData = false;
                this.changeDetector.detectChanges();
            },
            error: (error) => {
                console.error('Error fetching formula data:', error);
                this.isLoadingFormulaData = false;
                this.changeDetector.detectChanges();
            }
        });
    }

    prepareClimateCharts(_datapoint: Datapoint) {
        this.datapointsClimateChartService.subscribeLocationChartInstances(_datapoint.location, _datapoint.datasetID);
        this.datapointsClimateChartService.checkClimatePermissions(this.climateOverlayPermission, _datapoint.datasetID);
    }

    prepareClimatologyCharts(_datapoint: Datapoint) {
        this.datapointsClimateChartService.subscribeLocationClimatologyChartInstances(_datapoint.location, _datapoint.datasetID, this.climateOverlayPermission, this.changeDetector);
        this.datapointsClimateChartService.checkClimatologyPermissions(
            this.climateOverlayPermission, 
            _datapoint.datasetID,
            () => {
                this.setClimatologyTab('RISK_SCORING');
            }
        );
        this.prepareRegionCharts(_datapoint);
    }

    /**
     * Loads the Region tab: one chart per indicator for the bioclimatic zone the location falls
     * in. Loaded with the rest of Climate Change rather than when the tab opens, so Download Data
     * and Download Chart carry it either way.
     */
    private prepareRegionCharts(_datapoint: Datapoint) {
        this.regionRequest?.unsubscribe();
        this.regionCharts = [];
        this.datapointsClimateChartService.regionGraphs = [];
        this.datapointsClimateChartService.regionDownloadPayload = {};

        // Whether the tab shows is decided when the profile opens (loadBioclimaticRegion), so it is
        // there with the other tabs; the charts load inside it. With Bioclimatic not assigned the
        // backend answers with no charts.
        this.regionLoading = true;
        this.changeDetector.markForCheck();
        this.regionRequest = this.climateService.fetchBioclimaticZonesByLocation(_datapoint.location, _datapoint.datasetID)
            .pipe(catchError(() => of([] as ClimateChart[])))
            .subscribe(charts => {
                this.regionLoading = false;
                this.regionCharts = (charts || []).map(chart => toRegionChartItem(chart));
                (charts || []).forEach((chart, index) => {
                    this.datapointsClimateChartService.regionDownloadPayload[chart.indicatorCode || `region${index}`] = chart;
                });
                this.changeDetector.detectChanges();
            });
    }

    private loadBioclimaticRegion(_datapoint: Datapoint) {
        this.bioclimaticRegionRequest?.unsubscribe();
        this.bioclimaticRegion = null;
        this.datapointsClimateChartService.bioclimaticRegion = null;
        this.bioclimaticZonesEnabled = false;
        this.bioclimaticRegionRequest = this.climateService
            .fetchBioclimaticRegionByLocation(_datapoint.location, _datapoint.datasetID)
            .pipe(catchError(() => of(null)))
            .subscribe(region => {
                this.bioclimaticRegion = region?.region ? region : null;
                this.datapointsClimateChartService.bioclimaticRegion = this.bioclimaticRegion;
                // A zone comes back only when Bioclimatic is assigned, so it also decides the Region tab.
                this.bioclimaticZonesEnabled = !!this.bioclimaticRegion;
                if (!this.bioclimaticZonesEnabled && this.climatologyActiveTab === 'REGION') {
                    this.setClimatologyTab('RISK_SCORING');
                }
                this.changeDetector.detectChanges();
            });
    }

    onRegionChartInit(ec: any, item: RegionChartItem, index: number) {
        if (isUndefined(ec)) {
            return;
        }
        item.instance = ec;
        keepRegionLevelsBetweenTicks(ec);
        // Indexed rather than pushed, so the PDF keeps the tab's order whichever chart renders first.
        this.datapointsClimateChartService.regionGraphs[index] = { title: item.title, instance: ec };
        setTimeout(() => {
            // The first column holds the zone's region, not a period as in the other climate charts.
            ClimateChartHelper.attachDownloadHandler(ec, item.title, item.fileName, 'Region');
            ec.resize();
        }, 0);
    }

    setClimatologyTab(tab: 'CLIMATOLOGY' | 'CHANGE' | 'RISK_SCORING' | 'REGION' | 'CONSOLIDATED_RISK_SCORE') {
        this.climatologyActiveTab = tab;

        if (tab === 'CONSOLIDATED_RISK_SCORE') {
            this.prepareConsolidatedRiskScoreCharts(this._datapoint);
            this.loadInstantCalculationOptions();
        }

        setTimeout(() => {
            // Re-subscribe to any charts that have permissions but aren't initialized
            this.datapointsClimateChartService.resubscribeClimatologyChartsIfNeeded(
                this._datapoint.location, 
                this._datapoint.datasetID, 
                true
            );
            this.changeDetector.detectChanges();

            const instances: any[] = [];

            if (tab === 'CLIMATOLOGY') {
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDays.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txx.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTr.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlr.instance);
            } else if (tab === 'CHANGE') {
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.spi6Change.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDaysChange.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTrChange.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlrChange.instance);
            } else if (tab === 'RISK_SCORING') {
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDaysScore.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txxScore.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.spi6Score.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTrScore.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlrScore.instance);
            } else if (tab === 'REGION') {
                this.regionCharts.forEach(item => instances.push(item.instance));
            } else if (tab === 'CONSOLIDATED_RISK_SCORE') {
                this.consolidatedRiskScoreCharts.forEach(item => {
                    if (item.instance) {
                        instances.push(item.instance);
                    }
                });
                instances.push(this.instantChartItem?.instance);
            }

            instances.forEach(instance => {
                if (instance && typeof instance.resize === 'function') {
                    instance.resize();
                }
            });
        }, 0);
    }

    /**
     * Loads the stored graph for this location: one graph, for the vulnerability profile type the
     * location is assigned to.
     *
     * Built from the returned charts rather than from the list of profile types the dataset knows
     * about. A location is scored for its assigned profile type alone, so the response carries
     * exactly the one graph there is - walking the profile list instead would add an empty card
     * per other profile type in use on the account, which is the v1.0 model where a location held
     * a score against every type.
     */
    prepareConsolidatedRiskScoreCharts(_datapoint: Datapoint) {
        this.consolidatedRiskScoreLoading = true;
        this.consolidatedRiskScoreNoData = false;
        this.consolidatedRiskScoreCharts = [];
        this.datapointsClimateChartService.consolidatedRiskScoreGraphs = [];
        // The instant chart stays mounted across tab switches, so its chartInit does not fire
        // again to put it back in the download list this reset just emptied.
        this.registerConsolidatedRiskScoreGraph(this.instantChartItem);

        const request = this.climateService
            .fetchConsolidatedRiskScoreByDatapoint(_datapoint.datasetID, _datapoint.id)
            .pipe(catchError(() => of({} as { [profileId: string]: ClimateChart })))
            .subscribe(charts => {
                this.consolidatedRiskScoreLoading = false;

                this.consolidatedRiskScoreCharts = Object.entries(charts || {})
                    .filter(([, chart]) => !!chart && chart.hasData !== false)
                    .map(([profileId, chart]) => {
                        const title = chart.chartConfig?.yAxis?.labelName || 'Consolidated Risk Score';
                        return {
                            profileId: Number(profileId),
                            profileName: title,
                            title,
                            fileName: this.consolidatedRiskScoreChartService.toFileName(title),
                            option: this.consolidatedRiskScoreChartService.buildChartOptions(chart),
                            hasData: true,
                        };
                    });

                if (this.consolidatedRiskScoreCharts.length === 0) {
                    this.consolidatedRiskScoreNoData = true;
                    this.consolidatedRiskScoreNoDataMessage = 'No consolidated risk score for this location.';
                }

                this.changeDetector.detectChanges();
            });

        this.subscriptions.add(request);
    }

    onConsolidatedRiskScoreChartInit(ec: any, item: ConsolidatedRiskScoreChartItem) {
        if (isUndefined(ec)) {
            return;
        }

        item.instance = ec;

        // Register with the shared list so the profile chart download can append the
        // consolidated risk score charts to the same PDF as the other climate charts.
        this.registerConsolidatedRiskScoreGraph(item);

        if (item.hasData && item.option) {
            setTimeout(() => {
                if (item.instance) {
                    ClimateChartHelper.attachDownloadHandler(item.instance, item.title, item.fileName);
                    item.instance.resize();
                }
            }, 0);
        }
    }

    /**
     * Keeps the shared download list in step with the rendered charts: one entry per
     * vulnerability profile type, replaced rather than duplicated when a chart re-initialises
     * (switching tabs re-runs chartInit for the same profile).
     */
    private registerConsolidatedRiskScoreGraph(item: ConsolidatedRiskScoreChartItem) {
        if (!item?.hasData || !item.instance) {
            return;
        }
        const graphs = this.datapointsClimateChartService.consolidatedRiskScoreGraphs;
        const existing = graphs.findIndex(graph => graph.title === item.title);
        if (existing === -1) {
            graphs.push({ title: item.title, instance: item.instance });
        } else {
            graphs[existing].instance = item.instance;
        }
        // Stored graph first, instant result last, whichever registered first.
        const instantTitle = this.instantChartItem?.title;
        graphs.sort((a, b) => Number(a.title === instantTitle) - Number(b.title === instantTitle));
    }

    prepareNRICards() {
        this.summaryCard = this.createNRICard('Summary', 'summary.svg', this.getTessadataSummaryFieldIds(), false);
        this.nriCards.push(this.createNRICard('Avalanche', 'avalanche.svg', [TessadataNriFields.AVALANCHE_RSK, TessadataNriFields.AVALANCHE_EAL, TessadataNriFields.AVALANCHE_HLR]));
        this.nriCards.push(this.createNRICard('Coastal Flooding', 'coastalflooding.svg', [TessadataNriFields.COASTAL_FLOODING_RSK, TessadataNriFields.COASTAL_FLOODING_EAL, TessadataNriFields.COASTAL_FLOODING_HLR]));
        this.nriCards.push(this.createNRICard('Cold Wave', 'coldwave.svg', [TessadataNriFields.COLDWAVE_RSK, TessadataNriFields.COLDWAVE_EAL, TessadataNriFields.COLDWAVE_RSK]));
        this.nriCards.push(this.createNRICard('Drought', 'drought.svg', [TessadataNriFields.DROUGHT_RSK, TessadataNriFields.DROUGHT_EAL, TessadataNriFields.DROUGHT_HLR]));
        this.nriCards.push(this.createNRICard('Earthquake', 'earthquake.svg', [TessadataNriFields.EARTHQUAKE_RSK, TessadataNriFields.EARTHQUAKE_EAL, TessadataNriFields.EARTHQUAKE_HLR]));
        this.nriCards.push(this.createNRICard('Hail', 'hail.svg', [TessadataNriFields.HAIL_RSK, TessadataNriFields.HAIL_EAL, TessadataNriFields.HAIL_HLR]));
        this.nriCards.push(this.createNRICard('Heat Wave', 'heatwave.svg', [TessadataNriFields.HEATWAVE_RSK, TessadataNriFields.HEATWAVE_EAL, TessadataNriFields.HEATWAVE_HLR]));
        this.nriCards.push(this.createNRICard('Hurricane', 'tornado.svg', [TessadataNriFields.HURRICANE_RSK, TessadataNriFields.HURRICANE_EAL, TessadataNriFields.HURRICANE_HLR]));
        this.nriCards.push(this.createNRICard('Ice Storm', 'icestorm.svg', [TessadataNriFields.ICESTORM_RSK, TessadataNriFields.ICESTORM_EAL, TessadataNriFields.ICESTORM_HLR]));
        this.nriCards.push(this.createNRICard('Landslide', 'landslide.svg', [TessadataNriFields.LANDSLIDE_RSK, TessadataNriFields.LANDSLIDE_EAL, TessadataNriFields.LANDSLIDE_HLR]));
        this.nriCards.push(this.createNRICard('Lightning', 'lightning.svg', [TessadataNriFields.LIGHTNING_RSK, TessadataNriFields.LIGHTNING_EAL, TessadataNriFields.LIGHTNING_HLR]));
        this.nriCards.push(this.createNRICard('Riverine Flood', 'river.svg', [TessadataNriFields.RIVERINEFLOOD_RSK, TessadataNriFields.RIVERINEFLOOD_EAL, TessadataNriFields.RIVERINEFLOOD_HLR]));
        this.nriCards.push(this.createNRICard('Strong Wind', 'wind.svg', [TessadataNriFields.STRONGWIND_RSK, TessadataNriFields.STRONGWIND_EAL, TessadataNriFields.STRONGWIND_HLR]));
        this.nriCards.push(this.createNRICard('Tornado', 'tornado.svg', [TessadataNriFields.TORNADO_RSK, TessadataNriFields.TORNADO_EAL, TessadataNriFields.TORNADO_HLR]));
        this.nriCards.push(this.createNRICard('Tsunami', 'tsunami.svg', [TessadataNriFields.TSUNAMI_RSK, TessadataNriFields.TSUNAMI_EAL, TessadataNriFields.TSUNAMI_HLR]));
        this.nriCards.push(this.createNRICard('Volcanic Activity', 'volcanic.svg', [TessadataNriFields.VOLCANIC_RSK, TessadataNriFields.VOLCANIC_EAL, TessadataNriFields.VOLCANIC_HLR]));
        this.nriCards.push(this.createNRICard('Wildfire', 'wildfire.svg', [TessadataNriFields.WILDFIRE_RSK, TessadataNriFields.WILDFIRE_EAL, TessadataNriFields.WILDFIRE_HLR]));
        this.nriCards.push(this.createNRICard('Winter Weather', 'winter.svg', [TessadataNriFields.WINTER_RSK, TessadataNriFields.WINTER_EAL, TessadataNriFields.WINTER_HLR]));
    }

    get DistanceUnit() {
        return DistanceUnit;
    }

    getTessadataSummaryFieldIds() {
        return [TessadataNriFields.SUMMARY_RISK_RATING, TessadataNriFields.SUMMARY_EAL_RATING, TessadataNriFields.SUMMARY_SOVI_RATING, TessadataNriFields.SUMMARY_RESL_RATING];
    }

    createNRICard(title: string, icon: string, fieldIds: string[], removePrefixOfAttributes = true): NRICard {
        let properties: NRIKeyValue[] = [];
        let riskNumericalValues: number[] = [];
        fieldIds.forEach(id => {
            let datasetField = this.datasetFields[id];
            let datapointField = this.datapointFieldsByIds[id];
            if (!datapointField) {
                return;
            }
            let value: any = datapointField.textValue || datapointField.numberValue || datapointField.datetimeValue;
            if (value) {
                riskNumericalValues.push(NRIUtils.getNumericRiskValue(value) || 10);
            }
            let fieldName = datasetField.name;
            let label = removePrefixOfAttributes ? fieldName.substring(fieldName.indexOf('- ') + 2) : fieldName;
            properties.push({ label: label, value: value });
        });
        let maxRisk = Math.min.apply(Math, riskNumericalValues);
        let warnSignColor = NRIUtils.riskValueColorsByNumbers[maxRisk];

        return { title: title, icon: icon, properties: properties, warnSignColor: warnSignColor, visible: maxRisk <= 5 };
    }


    get DatasetFieldType() {
        return DatasetFieldType;
    }


    get DatasetFieldScope() {
        return DatasetFieldScope;
    }

    aerisFetch() {
        this.aerisService.getAerisCredentials().subscribe((value:any) =>{
        let aerisCredentials = Aeris.decodeAerisCredentials(value.aerisClient, value.aerisSecret)

        this.aerisService.fetchLocationProfile(AerisType.CONDITIONS, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, this._datapoint.location.y, this._datapoint.location.x).subscribe((value: any) => {
            const response = value.response;
            this.meteorologicalConditionsData = Aeris.computeAerisData(response, '', 0);
            const feildsToBeKeep = ["timestamp", "dateTimeISO", "tempC", "tempF", "feelslikeC", "feelslikeF", "dewpointC", "dewpointF", "humidity", "windDir", "windSpeedKPH", "windSpeedMPH", "windGustKPH", "windGustMPH"];
            this.meteorologicalConditionsData = this.meteorologicalConditionsData.filter(meteorologicalConditions => {
                return (meteorologicalConditions.text !== "" && feildsToBeKeep.includes(meteorologicalConditions.text)) && meteorologicalConditions.value !== "";
            })
        }, (error) => {
            this.meteorologicalConditionsData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.PLACES, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, this._datapoint.location.y, this._datapoint.location.x).subscribe((value: any) => {
            const response = value.response;
            this.placesData = Aeris.computeAerisData(response, '', 0);
            const feildsToBeKeep = ["state", "stateFull", "country", "countryFull", "region", "regionFull", "elevM", "elevFT", "tz", "tzname", "distanceKM", "distanceMI"];
              this.placesData = this.placesData.filter(places => {
                return places.text !== "" && feildsToBeKeep.includes(places.text) && places.value !== "";
            });
        }, (error) => {
            this.placesData = [];
        });
    });
    }

    fetchClosestPOI() {
        if (this.tessadataEnabled) {
            let distanceInM = ComputationUtils.getDistanceInMeters(this.tessadataPOIDistance, this.tessadataPOIDistanceUnit);
            this.tessadataPOISubmittedDistanceUnit = this.tessadataPOIDistanceUnit;
            const poiClosestFilter: PoiClosestFilter = {
                latitude: this._datapoint.location.y,
                longitude: this._datapoint.location.x,
                externalDatasetId: this.tessadataPOIDataset.datasetId,
                distanceInMeters: distanceInM,
                distanceUnit: this.tessadataPOIDistanceUnit,
                limit: this.tessadataPOILimit
            };
            this.poiClosestSubmittedFilter.emit(poiClosestFilter);
            this.tessadataService.fetchClosestPOIDetails(poiClosestFilter).subscribe(
                locationDetails => {
                    this.tessadataPOIDetails = locationDetails.datasets;
                    if (this.tessadataPOIDetails.length) {
                        let tessadataDatasetStructure = this.tessadataPOIDatasetsStructures.find(structure => structure.datasetId === this.tessadataPOIDetails[0].datasetId);
                        this.tessadataPOIDetails.forEach(poi => poi.fields.forEach(field => {
                            let tessadataField = tessadataDatasetStructure.fields.find(f => f.fieldId === field.id);
                            field.label = tessadataField.fieldLabel;
                            field.type = tessadataField.fieldType;
                            if (field.label === 'Distance') {
                                field.value = field.value ? String(ComputationUtils.getDistanceInUnit(Number(field.value), this.tessadataPOIDistanceUnit)) : '';
                            }
                        }));
                    }
                    this.changeDetector.detectChanges();
                }
            );
        }
    }

    private isPrecisely(field: DatasetField) {
        return field.displayName.startsWith('Precisely Wildfire') || field.displayName.includes('(APG)');
    }

    // private isTensorFlight(field: DatasetField) {
    //     return field.tags[0] && field.tags[0].toUpperCase() === "TENSORFLIGHT";
    // }

    private isE2Value(field: DatasetField) {
        return field.tags[0] && field.tags[0].toUpperCase() === "E2VALUE";
    }

    private isMunichRe(field: DatasetField) {
        return field.id.startsWith('munichre_hazards');
    }

    private isPreciselyWildfireRisk(field: DatasetField) {
        return field.id.startsWith('precisely_wildfire_risk');
    }

    private isPreciselyCrime(field: DatasetField) {
        return field.id.startsWith('precisely_crime');
    }

    private isPreciselyBuilding(field: DatasetField) {
        return field.id.startsWith('precisely_building');
    }

    private isCustomScore(field: DatasetField) {
        return field.scope.toUpperCase() === DatasetFieldScope.CUSTOM_SCORE;
    }

    sidePanelOpenState = true;
    hazardScoresOpenState = true;
    riskScoresOpenState = true;

    displayedColumns: string[] = ['name', 'none', 'low'];

    displayedRiskColumns: string[] = ['name', 'none', 'low'];


    getPointerPosition(element: any): number {
        const field = this._datapoint.fields.find(field => field.id === element.values[1].id);
        if (field !== undefined) {
            return MinuchRe.getPointerPosition(field.numberValue);
        }
        return 0;
    }

    getTooltipText(element: any): string {
        const fieldRiskScore = this._datapoint.fields.find(field => field.id === element.values[0].id);
        const fieldRiskIndex = this._datapoint.fields.find(field => field.id === element.values[1].id);
        if (fieldRiskIndex !== undefined && fieldRiskScore !== undefined) {
            return MinuchRe.getTooltipText(fieldRiskIndex.numberValue, fieldRiskScore.textValue);
        } else if (fieldRiskScore === undefined && fieldRiskIndex !== undefined) {
            return `Risk Score:  - Risk Index: ${fieldRiskIndex.numberValue}`;
        } else if (fieldRiskScore !== undefined && fieldRiskIndex === undefined) {
            return `Risk Score: ${fieldRiskScore.textValue} - Risk Index: `;
        } else {
            const defaultRiskIndex = 0;
            const defaultRiskScore = "Low";
            return `Risk Score: ${defaultRiskScore} - Risk Index: ${defaultRiskIndex}`;
        }
    }

    downloadMunichReport() {
        this.subscriptions.add(
            this.downloadService
                .downloadMunichReReport(this._datapoint.datasetID,this._datapoint.id)
                .subscribe(
                    (response) => {
                        const url =  response.url;
                        window.location.href = response.url;
                    },
                    (error) =>
                        this.notifService.error(
                            "Something went wrong during download"
                        )
                )
        )
    }

    downloadMunichReSingleLocationReport() {
        this.subscriptions.add(
            this.downloadService
                .downloadMunichReReportReportingEdition(this._datapoint.datasetID, this._datapoint.id)
                .subscribe(
                    (response) => {
                        const url = response.url;
                        window.location.href = response.url;
                    },
                    (error) =>
                        this.notifService.error(
                            "Something went wrong during download"
                        )
                )
        )
    }

    isFieldValueValid(datasetField: DatasetField) {
        let value: any;
        if (this.datasetFields[datasetField.id].baseType === DatasetFieldType.DATE_TIME) {
            value = datasetField.datetimeValue;
        } else if(this.datasetFields[datasetField.id].baseType === DatasetFieldType.NUMBER) {
            value = datasetField.numberValue;
        } else if (this.datasetFields[datasetField.id].baseType === DatasetFieldType.TEXT) {
            value = datasetField.textValue;
        }
        if(value === null || value === undefined || value === "null"){
            return false;
        }
        return true;
    }
}


interface NRICard {
    title: string;
    icon: string;
    properties: NRIKeyValue[];
    warnSignColor: string;
    visible: boolean;
}

interface NRIKeyValue {
    label: string;
    value: string;
}
